module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PvZcMl/tc-custom/9780795350689.jpg?1705038285551",
      "alt": "This image is the cover for the book Murder by Quill"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder by Quill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A writer’s retreat in northern Scotland becomes a master class in murder in this clever mystery novel.")]), _c('br'), _c('br'), _vm._v("The winners of a prestigious writing contest have been gathered for a writer’s retreat in the home of wealthy philanthropist Hugh Barrabault. Located in a remote coastal village of northern Scotland, the elegant castle and its immaculate grounds are intended to inspire serenity and reflection—the ideal conditions for literary productivity. But no one is feeling very serene when their host is found murdered."), _c('br'), _c('br'), _vm._v("Hugh Barrabault had the power to make any of his guests famous overnight. Who could possibly have wanted him dead? The murder weapon—a writing quill of unusual design—is their only clue. As the investigation begins and secrets are revealed, the former strangers are forced to make alliances. Everyone agrees that someone must take change . . . but what if that someone is the murderer?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Phillips\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0